import { Link as ReactLink } from "react-router-dom";
import { Typography, Link, Button } from "@mui/material";
import styled from "@emotion/styled";
import { useState } from "react";
import { toast } from "react-toastify";
import { helpHttp } from "../../../helper/helpHttp";
import Fields from "./SignUpFields";

const SignUpForm = () => {
  const [emailToValidate, setEmailToValidate] = useState("");
  const { post } = helpHttp();

  const requestNewCode = () => {
    if (!emailToValidate) {
      toast.error(
        "Ingresa tu correo electrónico para solicitar un nuevo código",
      );
      return;
    }

    post("usuarios/resendConfirmationCode", {
      headers: { "Content-Type": "application/json" },
      body: { correo: emailToValidate },
    })
      .then((response) => {
        if (response.codigo === "200") {
          toast.success("Se ha enviado un nuevo código de verificación");
        } else {
          toast.error(response.mensaje);
        }
      })
      .catch((error) => toast.error(error.message || "Ha ocurrido un error"));
  };

  return (
    <StyledFormContainer>
      <Fields
        emailToValidate={emailToValidate}
        setEmailToValidate={setEmailToValidate}
      />
      <StyledRegister>
        <Typography>¿Tienes una cuenta?</Typography>
        <Link component={ReactLink} variant="text" to="/sign-in">
          Iniciar sesión
        </Link>
      </StyledRegister>
      {emailToValidate && (
        <Button onClick={requestNewCode} sx={{ fontSize: 12 }}>
          Solicita un nuevo código
        </Button>
      )}
    </StyledFormContainer>
  );
};

const StyledFormContainer = styled.div`
  background: #fff;
  /* max-width: 550px; */
  max-height: calc(100vh - 210px);
  overflow: auto;
  flex: 1;
  padding: 20px 20px 40px 20px;
  border-radius: 10px;
  color: #114c97;
  text-align: center;

  @media (max-width: 991px) {
    max-height: none;
  }
`;

const StyledRegister = styled.div`
  justify-content: center;
  margin-top: 20px;
  @media (min-width: 768px) {
    grid-column: auto / span 2;
  }
  align-items: center;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

export default SignUpForm;
